import { Shield, X, Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
// Navbar Component
const Navbar = ({ currentPage, setCurrentPage, isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About Us' },
    { id: 'help', label: 'Help' },
    { id: 'profile', label: 'Profile' },
    { id: 'logout', label: 'Logout' }


  ];

  const navigate = useNavigate();
  const handleNavClick = (itemId) => {
    if (itemId === 'logout') {
      handleLogout();
    } else {
      setCurrentPage(itemId);
    }
  };

  const handleLogout = () => {
    // Clear any stored authentication data
    // localStorage.removeItem('authToken');
    // localStorage.removeItem('userData');
    // You can also clear sessionStorage if you're using it
    // sessionStorage.clear();
    
    // Redirect to login page
    navigate('/'); // or wherever your login page is
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-brand">
          
          <Shield className="brand-icon" />
          <span className='nav-brand-span'>B.R.A.V.O.</span>
        </div>
        
        <div className="nav-menu">
          {navItems.map(item => (
            <button
              key={item.id}
              className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X /> : <Menu />}
        </button>
      </div>
      
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          {navItems.map(item => (
            <button
            type="button"
              key={item.id}
              className={`mobile-nav-link ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => {
                handleNavClick(item.id);
                setIsMobileMenuOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
      
      <style jsx>{`
        .navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          background: rgba(10, 35, 66, 0.95);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .nav-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 2rem;
        }
        
        .nav-brand {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 1.5rem;
          font-weight: 700;
          color: #FF4B2B;
        }

        .nav-brand-span{
          color: #ffffff;
        }
        
        .brand-icon {
          width: 32px;
          height: 32px;
        }
        
        .nav-menu {
          display: flex;
          gap: 2rem;
        }
        
        .nav-link {
          background: none;
          border: none;
          color: white;
          font-size: 1rem;
          cursor: pointer;
          padding: 0.5rem 1rem;
          border-radius: 8px;
          transition: all 0.3s ease;
        }
        
        .nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
          transform: translateY(-2px);
        }
        
        .nav-link.active {
          background: linear-gradient(135deg, #FF416C 0%, #FF4B2B 100%);
        }
        
        .mobile-menu-toggle {
          display: none;
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 0.5rem;
        }
        
        .mobile-menu {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: rgba(10, 35, 66, 0.98);
          backdrop-filter: blur(10px);
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .mobile-nav-link {
          display: block;
          width: 100%;
          background: none;
          border: none;
          color: white;
          font-size: 1rem;
          cursor: pointer;
          padding: 1rem 2rem;
          text-align: left;
          transition: all 0.3s ease;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        }
        
        .mobile-nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        
        .mobile-nav-link.active {
          background: linear-gradient(135deg, #FF416C 0%, #FF4B2B 100%);
        }
        
        @media (max-width: 768px) {
          .nav-menu {
            display: none;
          }
          
          .mobile-menu-toggle {
            display: block;
          }
          
          .mobile-menu {
            display: block;
            animation: slideInFromRight 0.3s ease;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;